export default __webpack_public_path__ + "images/package_icon--primary.b3a652f.svg";